<template>
  <div class="workflow-card workflow-card-header rounded-2 position-relative mx-auto mx-lg-0">
    <div class="px-3 pt-3">
      <h4 class="text-white mb-0">
        <inline-editable-text
          @change="onUpdateTitle"
          :value="sequence.name"
          :inline="false"
          :reset-on-update="false"
          :reset-on-cancel="false"
          :lost-focus-is-update="false"
          :is-editable="isEditable"
          />
      </h4>
    </div>
    <div class="action-card-details px-3 py-2 text-white">
      <!-- <EditableIcon v-model="icon" /> -->

      <!-- TODO: inline edit description -->
      <span class="caption">Description:</span>
      <p class="mb-0 text-truncate">{{sequence.description}}</p>

      <span class="caption">Repeat:</span>
      <template v-if="userOverrideTemplateRepeat">
        {{sequence.templateRepeat}}x (User override)
      </template>
      <template v-else-if="sequence.templateRepeat >= 1e99">
        infinitely
      </template>
      <template v-else>
        {{sequence.templateRepeat}}x
      </template>
      <!-- todo: show picture -->
    </div>
    <div class="workflow-card-controls px-3 py-3 text-right">

      <div v-if="!isEditable">
        <router-link :to="{ name: 'edit_sequence', params: { sequenceId: this.sequence.$id } }">
          <el-button type="mini" class="p-1">Edit sequence</el-button>
        </router-link>
      </div>

      <ellipsis-button
        v-if="isEditable"
        placement="bottom"
        heading="Sequence actions"
        :show-options="['edit', 'slot', 'delete']"
        @edit="onShowEditModal"
        @delete="onRemove">

        <el-button
          @click="onImportCSV"
          size="mini"
          class="ml-0 btn-block">
          Import from CSV<br />
          (Get template <a :href="url_sequence_template" target="_blank">here</a>)
        </el-button>
        <el-button
          @click="onConvertToTemplate"
          size="mini"
          class="ml-0 btn-block"
          :disabled="true">
          Convert to Template
        </el-button>
        <el-button
          @click="onDuplicateSequence"
          size="mini"
          class="ml-0 btn-block"
          :disabled="true">
          Duplicate sequence
        </el-button>
        <el-button
          @click="onArchiveSequence"
          size="mini"
          class="ml-0 btn-block"
          :disabled="true">
          Archive
        </el-button>
        <el-button
          @click="onShareSequence"
          size="mini"
          class="ml-0 btn-block"
          :disabled="true">
          Share
        </el-button>

      </ellipsis-button>

    </div>
    <div v-if="showConnection" class="workflow-string position-absolute"></div>

    <el-dialog
      title="Sequence configuration"
      :visible.sync="dialogVisible"
      width="80%">

      <!-- TODO: move to modal -->
      <!-- TODO: allow edit picture -->
      <!-- TODO: allow edit descrioption -->
      <el-form label-position="left" label-width="200px" @submit.native.prevent size="small">
        <el-form-item label="Repeat template (default)">
          <el-input-number v-model="form.templateRepeat" :step="1" />
          <el-checkbox v-model="infinitRepeat" class="ml-4">Repeat infinitely</el-checkbox>
        </el-form-item>
        <el-form-item label="What if a session can not be scheduled?">
          <el-switch
            size="small"
            v-model="form.allowSessionToBeSkipped"
            active-text="Skip sessions when necessary"
            inactive-text="Try to plan missed sessions as soon as possible"
            :active-value="true"
            :inactive-value="false">
          </el-switch>
        </el-form-item>
        <el-form-item label="Description">
          <el-input type="textarea" v-model="form.description"></el-input>
        </el-form-item>
        <el-form-item label="Picture">
          <ImageUpload v-model="form.picture" bucket="sequence_pics" />
        </el-form-item>
      </el-form>

      <!-- <pre>{{form}}</pre> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="onSaveDialog">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ImageUpload from '@/components/Elements/ImageUpload'
import FilePrompt from "@/components/Mixins/Prompts/FilePrompt"
import Papa from 'papaparse'

export default {
  name: "WorkflowAction",
  mixins: [ FilePrompt ],
  props: {
    sequence: {},
    // title: {},
    // description: {},
    // picture: {},
    showConnection: {
      default: true
    },
    isEditable: {
      default: true
    },
    userOverrideTemplateRepeat: {
      default: null
    }
  },
  data: () => ({
    // icon: {
    //   symbol: "hourglass-start",
    //   bgColor: "#467fcf",
    //   fgColor: "#ffffff"
    // },
    dialogVisible: false,
    form: {
      templateRepeat: 1,
      allowSessionToBeSkipped: false,
      description: '...',
    },
    infinitRepeat: false,
    url_sequence_template: "https://docs.google.com/spreadsheets/d/1qFZjTaSLukMdo11zVziChnwxt49EiChgCepTgtU8ZRM/edit?usp=sharing",
  }),
  methods: {
    onShowEditModal() {
      this.dialogVisible = true
      // this.form = Object.assign({}, this.sequence)
      this.form = this.sequence.clone();
      if ( this.form.description === undefined ) {
        this.form.description = '';
      }
      this.infinitRepeat = false;
    },
    onUpdateTitle( name ) {
      console.log("onUpdateTitle", name, this.sequence.$id);
      this.$models.sequence.update( this.sequence.$id, { name: name })
    },
    onRemove() {
      this.$models.sequence.remove( this.sequence.$id ).then(() => {
        this.$router.push( '/sequence/' );
      })
    },
    onSaveDialog() {
      if ( this.infinitRepeat ) {
        this.form.templateRepeat = 1e99; // Number.Infinity;
      }
      if ( this.form.$isValid ) {
        this.form.write();
        this.dialogVisible = false;
      } else {
        console.warn("Invalid document");
      }
    },
    onConvertToTemplate() {
      console.log("onConvertToTemplate - TODO");
    },
    onImportCSV() {
      this.$file_prompt({
        accept: '.csv,text/csv,application/vnd.ms-excel'
      }).then(({ file, done }) => {
        return new Promise((resolve, reject) => {
          Papa.parse(file.raw, {
            header: true,
            dynamicTyping: true,
            complete: (res) => {
              resolve(res);
              done();
            }
          });
        });
      }).then(results => {

        let actions = results.data.map(sequenceItemImport => {
          let item = this.$models.sequenceItem.new_from_template(
            { itemType: sequenceItemImport.type }, sequenceItemImport);
            return item.$state
        })

        this.$emit('add', {
          groupId: -1,
          id: -1,
          title: 'Imported sequence',
          description: '',
          icon: { symbol: 'hourglass-start', bgColor: 'black', fgColor: 'white' },
          actions
        })

        this.$message('Tasklist successfully imported');
      }).catch(error => {
        this.$message.error('Can not read file: ' + error);
      })
    },
    onDuplicateSequence() {
      console.log("onDuplicateSequence - TODO");
    },
    onArchiveSequence() {
      console.log("onArchiveSequence - TODO");
    },
    onShareSequence() {
      console.log("onShareSequence - TODO");
    },
  },
  components: {
    ImageUpload,
    // EditableIcon,
  }
}
</script>

<style>
.workflow-card-header .action-card-details .caption {
  color: #EEE;
  font-variant: small-caps;
}
</style>
